import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pb-32 pt-16 w-[90%] mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-center mb-5 text-primary-500 text-4xl lg:text-5xl" }, " Forgot Password ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-7" }, "Kindly provide your email for us to send you a reset password link.", -1)
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-8" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-400" }, [
    /*#__PURE__*/_createTextVNode("Dont have an account yet? "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/signup",
      class: "font-bold text-primary-500"
    }, "Sign up now")
  ])
], -1)

import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import GeneralModal from '@/components/GeneralModal.vue';
import { useRouter } from 'vue-router';
import AuthService from '@/classes/AuthService';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref()
const errors = ref([])
const show = ref(false);

const router = useRouter();

const form = ref({
    email: '',
})

const submit = async() => {
    try {
        loader.value = true;

        const response = await AuthService.forgotPassword(form.value.email)
        
        loader.value      = false;
        show.value = true
        form.value.email  = '';
        errorMsg.value    = '';
    }catch(error){
        loader.value = false;
        showError.value = true;
        errorMsg.value = error.response.data.message
        errors.value = error.response.data.errors
    }
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("form", {
          class: "w-full lg:w-[350px] mx-auto",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              type: "email",
              placeholder: "Email",
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
              error: errors.value.email ? errors.value.email[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ButtonComponent, {
              disabled: loader.value,
              text: "Submit",
              type: 'submit',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (submit()))
            }, null, 8, ["disabled"])
          ])
        ], 32),
        _hoisted_6
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(GeneralModal, {
        width: "w-[416px]",
        title: "Password reset link sent!",
        content: "Kindly check your email to access the password reset link we sent you.",
        "action-text": "Okay",
        show: show.value,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (show.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (show.value = false))
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"])
    ]),
    _: 1
  }))
}
}

})